<div class="success-modal" [ngClass]="'notification-' + iconClass">
  <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
  <div class="success-icon-container">
    <div class="success-circle" [ngClass]="'circle-' + iconClass">
      <mat-icon *ngIf="iconClass === 'success'">check</mat-icon>
      <mat-icon *ngIf="iconClass === 'error'">error</mat-icon>
      <mat-icon *ngIf="iconClass === 'info'">info</mat-icon>
      <mat-icon *ngIf="iconClass === 'toyota-info'">info</mat-icon>
      <mat-icon *ngIf="iconClass === 'deleted'">delete</mat-icon>
    </div>
  </div>
  <h2 class="success-title" [ngClass]="'title-' + iconClass">{{ title }}</h2>
  <p class="success-message">{{ data.message }}</p>
</div>
